import styled from '@emotion/styled';
import FileChipFilename from '../../FileChip/FileChipFilename';
import { ButtonBase } from '@mui/material';

const ClickableImageFilename = styled(
  FileChipFilename.withComponent(ButtonBase),
)(({ theme }) => ({
  height: '100%',
  font: 'inherit',
  fontSize: 13,
  fontWeight: 500,
  lineHeight: '32px',
  display: 'block',
  transition: theme.transitions.create(['background-color']),
  ':hover': {
    backgroundColor: theme.palette.action.hover,
  },
  ':focus': {
    backgroundColor: theme.palette.action.selected,
  },
}));

export default ClickableImageFilename;
